import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerComponent, DatepickerOptions } from 'ng2-datepicker';
import { FilterDetail } from 'src/app/model/lookup/FilterDetail';
import { FilterOrderDetail } from 'src/app/model/lookup/FilterOrderDetail';
import { OrderService } from 'src/app/service/order.service';
import { RequestStatusEnum } from 'src/app/service/enums/requestStatus.enum';
import { LoaderService } from 'src/app/service/loader.service';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-rdc-primary-data-filter-popup',
  templateUrl: './rdc-primary-data-filter-popup.component.html'
})
export class RdcPrimaryDataFilterPopupComponent extends BaseComponent implements OnInit {


    @ViewChild("fromDate", { static: false }) fromDate: DatepickerComponent
    @ViewChild("toDate", { static: false }) toDate: DatepickerComponent
     selectedFilters: FilterDetail = new FilterDetail();
    filterDetails: FilterOrderDetail = new FilterOrderDetail();
     
    fromDatePickeroptions: DatepickerOptions = {
    placeholder: this.appTranslateService.getTranslate("pleaseSelectFromDate"), // placeholder in case date model is null | undefined, example: 'Please pick a date'
    format: 'dd MMM, yyyy', // date format to display in input
    formatTitle: 'dd MMM, yyyy',
    formatDays: 'EEEEE'
  };
    toDatePickeroptions: DatepickerOptions = {
    placeholder: this.appTranslateService.getTranslate("pleaseSelectToDate"), // placeholder in case date model is null | undefined, example: 'Please pick a date'
    format: 'dd MMM, yyyy', // date format to display in input
    formatTitle: 'dd MMM, yyyy',
    formatDays: 'EEEEE'
  };
  constructor(
    
    public activeModal: NgbActiveModal,
    private loaderService: LoaderService,
    private orderService: OrderService ) { 
    super();

   }

  ngOnInit(): void {
    this.loadFilters();
  }

  loadFilters() {

    this.loaderService.show();
    this.orderService.GetFilterDetails().subscribe(
      res => {

        this.loaderService.hide();
        if (res.successed) {
          this.filterDetails = res.data;
          this.filterDetails.filteredRequestStatuses = this.filterDetails.requestStatuses;
        }
        else {

          this.toastrAlertService.errorToastr(res.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate(error.error));
        }
      }
    )

  }


  closeActiveModal() {
    this.activeModal.close(null);
  }

  applyFilter() {
    if (this.selectedFilters.fromDate && this.selectedFilters.fromDate !== null) {
      this.selectedFilters.fromDateYear = this.selectedFilters.fromDate.getFullYear();
      this.selectedFilters.fromDateMonth = this.selectedFilters.fromDate.getMonth() + 1;
      this.selectedFilters.fromDateDay = this.selectedFilters.fromDate.getDate();
    } else {
      this.selectedFilters.fromDateYear = undefined;
      this.selectedFilters.fromDateMonth = undefined;
      this.selectedFilters.fromDateDay = undefined;
    }

    if (this.selectedFilters.toDate && this.selectedFilters.toDate !== null) {
      this.selectedFilters.toDateYear = this.selectedFilters.toDate.getFullYear();
      this.selectedFilters.toDateMonth = this.selectedFilters.toDate.getMonth() + 1;
      this.selectedFilters.toDateDay = this.selectedFilters.toDate.getDate();
    } else {
      this.selectedFilters.toDateYear = undefined;
      this.selectedFilters.toDateMonth = undefined;
      this.selectedFilters.toDateDay = undefined;
    }

  
    var obj = { filterApplied: false, selectedFilters: this.selectedFilters };

    if (this.selectedFilters.fromDate && this.selectedFilters.fromDate !== null)
      obj.filterApplied = true;
    if (this.selectedFilters.toDate && this.selectedFilters.toDate !== null)
      obj.filterApplied = true;



    if (this.selectedFilters.requestStatuses && this.selectedFilters.requestStatuses !== null && this.selectedFilters.requestStatuses.length > 0)
      obj.filterApplied = true;

   

    this.activeModal.close(obj);
  }


  clearFromDate() {
    this.fromDate.displayValue = '';
    this.fromDate.innerValue = new Date();
    this.selectedFilters.fromDate = undefined;
    this.selectedFilters.fromDateYear = undefined;
    this.selectedFilters.fromDateMonth = undefined;
    this.selectedFilters.fromDateDay = undefined;
  }

  clearToDate() {
    this.toDate.displayValue = '';
    this.toDate.innerValue = new Date();
    this.selectedFilters.toDate = undefined;
    this.selectedFilters.toDateYear = undefined;
    this.selectedFilters.toDateMonth = undefined;
    this.selectedFilters.toDateDay = undefined;
  }
}
